import New from "../../../assets/images/news/new.png";
import Leaf from "../../../assets/images/news/icon1.png";
import Sound from "../../../assets/images/news/icon8.png";
import Recipe from "../../../assets/images/news/receipe.png";
const newsData = [
  {
    id: 1,
    title: "今月の産直野菜",
    img: New,
  },
  {
    id: 2,
    title: "おすすめ商品",
    img: Leaf,
  },
  {
    id: 3,
    title: "入荷終了のお知らせ",
    img: Sound,
  },
  {
    id: 4,
    title: "レシピ",
    img: Recipe,
  },
];
export default newsData;
